(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('policyRulesListSelector', ["path", "feature", "$timeout", "$q", function (path, feature, $timeout, $q) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('policy-rules/list-selector').template('list-selector'),
            scope: {
                model: '=policyRulesListSelector',
                variants: '=',
                filterBy: '<'
            },
            link: function ($scope, element, attrs) {
                function processItems(items, processor) {
                    _(items).each(function (item) {
                        processor(item);
                        if (item.items) {
                            processItems(item.items, processor);
                        }
                    });
                }
                $scope.items = angular.copy($scope.variants);
                $scope.filtering = false;
                processItems($scope.items, function (item) {
                    if (item.items) {
                        item.collapsed = true;
                    }
                });
                processItems($scope.items, function (item) {
                    if (item.id && _($scope.model).find(function (itemId) {
                            return item.id === itemId;
                        })) {
                        item.checked = true;
                    }
                });
                $scope.dlpCPClass = function () {
                    if (feature.checkpointTheme) {
                        return { 'dlp-checkpoint': true };
                    }
                    return { 'dlp-checkpoint': false };
                };
                $scope.$watch('items', function () {
                    var selected = [];
                    processItems($scope.items, function (item) {
                        if (item.id && item.checked) {
                            selected.push(item.id);
                        }
                    });
                    $scope.model = selected;
                }, true);
                $scope.$watch('filterBy', function () {
                    $scope.filtering = true;
                    $timeout(function () {
                        $scope.filtering = false;
                    }, 1000);
                });
            }
        };
    }]);
}());